var CloudflowURL = require("./CloudflowURL.js");
var Query = require("../../Table/js/Query.js");
var QueryApplier = require("./QueryApplier.js");
var CloudflowObject = require("./CloudflowObject.js");
var GUID = require("./GUID.js");

function timeStamp() {
    return (new Date()).toISOString().substring(0, 19) + "Z";
}

/**
 * @constructor FileConnection
 * @description Class to apply all CRUD api-alive methodes on a JSON-file
 * @param {String} pURL The cloudflow url of the file
 * @param {String} pRelativeBasePath The relative path
 * @param {String} pContentType The type of the file, we now only support "json"
 */
function FileConnection(pURL, pRelativeBasePath, pContentType) {
    this.loadingDef; // promise of loading content
    this.rootParameter; // the root of the file content, "" or "documents"
    this.content; // rows content
    this.fileEtag; // value of etag 
    this.fileModification; // value of last modification time stamp 
    this.error; // object of error
    this.autoAdaptedURL; // log to trace url change
    this.dirty = false;
    this.reasonToStop = null; // abort message
    this.setURL(pRelativeBasePath, pURL);
    this.setContentType(pContentType);
}

FileConnection.fromJSON = function(json) {
    return new FileConnection(json.url, json.relativeBasePath, json.contentType);
};

FileConnection.prototype = {

    constructor: FileConnection,

    /**
     * @description Set the URL of the file
     * @name FileConnection#setURL
     * @function
     * @param {String} pRelativeBasePath 
     * @param {String} pURL 
     */
    setURL: function(pRelativeBasePath, pURL) {
        if (typeof pURL !== "string" || pURL.length <= 0) {
            throw new Error("parameter url must be a not empty string");
        }
        this.url = pURL;
        this.relativeBasePath = pRelativeBasePath;
        this.cloudflowURL = new CloudflowURL(this.relativeBasePath, this.url, true);
    },

    /**
     * @description Get the URL of the file
     * @function
     * @name FileConnection#getURL
     * @returns The url of the file
     */
    getURL: function() {
        return this.url;
    },

    getRelativeBasePath: function(){
        return this.relativeBasePath;
    },

    setContentType: function(pContentType){
        if (pContentType === undefined || pContentType === "json") {
            this.contentType = "json";
        } else {
            throw new Error("unsupported contentType " + pContentType);
        }
    },

    getContentType: function(){
        return this.contentType;
    },

    getError: function() {
        return this.error;
    },

    _setError: function(pErrorCode, pError, pXHR) {
        var returnErrorObj;
        if (pXHR && typeof pXHR.responseText === "string") {
            try {
                returnErrorObj = JSON.parse(pXHR.responseText);
            } catch(e) {}
        }
        if (pErrorCode === "error" && pError === "Not Found") {
            this.error = {
                "error_code": "file_not_found",
                "error": "File not found"
            };
            if (returnErrorObj !== undefined && returnErrorObj.messages !== undefined && Array.isArray(returnErrorObj.messages.messages) &&
                returnErrorObj.messages.messages.length > 0) {
                    this.error.error = returnErrorObj.messages.messages[0].description;
                }
        } else if (returnErrorObj !== undefined) {
            this.error = returnErrorObj;
        } else {
            this.error = {
                "error_code": pErrorCode,
                "error": pError
            };
        }
    },

    /**
     * @function
     * @description Read the content of the file
     * @name FileConnection#load
     */
    load: function(){
        var that = this;
        var promiseDict = Promise.withResolvers();
        this.loadingDef = promiseDict.promise;
        var getUrl = "/portal.cgi?asset=download_file&url=" + encodeURIComponent(this.cloudflowURL.getCloudflowPath());
        if (typeof api_util.get_session() === "string" && api_util.get_session().length > 0) {
            getUrl += "&session=" + api_util.get_session();
        }
        var xhttp = new XMLHttpRequest();
        xhttp.onload = function(pEvent) {
            if (xhttp.status < 200 || (xhttp.status > 299)) {
                that.rootParameter = "";
                that.content = null;
                var errorObject = {
                    error_code: "http",
                    error: xhttp.statusText
                }
                if (typeof xhttp.responseText === "string" && xhttp.responseText.length > 0) {
                    try {
                        errorObject = Object.assign(errorObject, JSON.parse(xhttp.responseText));
                    } catch(e) {}
                }
                that._setError(errorObject.error_code, errorObject.error, xhttp);
                console.error(errorObject);
                promiseDict.reject({xhr: xhttp, error_code: errorObject.error_code, error: errorObject.error});
            } else {
                let data = null;
                if (typeof xhttp.responseText === "string" && xhttp.responseText.length > 0) {
                    if (that.getContentType() === "json") {
                        try {
                            data = JSON.parse(xhttp.responseText);
                        } catch(e) {
                            that.content = null;
                            that.rootParameter = "";
                            promiseDict.reject({xhr: xhttp, error_code: "content_not_json", error: e.message});
                            return;
                        }
                    } else {
                        console.error("unsupported content type", that.getContentType());
                        promiseDict.reject({xhr: xhttp, error_code: "unuspported_contenttype", error: "unuspported contenttype"});
                        return;
                    }
                }
                if (data && !Array.isArray(data) && typeof data === "object" && Object.keys(data).length === 1 && Array.isArray(data.documents)) {
                    // special frankied styled xml's
                    that.rootParameter = "documents";
                    that.content = data.documents;
                } else {
                    that.rootParameter = "";
                    if (data === null || data === undefined || data === "") { // empty file
                        that.content = [];
                    } else {
                        that.content = data;
                    }
                }
                promiseDict.resolve(that.content);
            } 
        };
        xhttp.onerror = function(pEvent) {
            if (xhttp.statusText === "OK" && xhttp.status === 200 && xhttp.responseText === "") {
                // empty file
                that.rootParameter = "";
                that.content = [];
                promiseDict.resolve([]); // reset to solved
            } else {
                that.rootParameter = "";
                that.content = null;
                var errorObject = {
                    error_code: "http_error_load",
                    error: xhttp.statusText
                }
                if (typeof xhttp.responseText === "string" && xhttp.responseText.length > 0) {
                    try {
                        errorObject = Object.assign(errorObject, JSON.parse(xhttp.responseText));
                    } catch(e) {}
                }
                that._setError(errorObject.error_code, errorObject.error, xhttp);
                console.error(errorObject);
                promiseDict.reject({xhr: xhttp, error_code: errorObject.error_code, error: errorObject.error});
            }
        }
        xhttp.onabort = function(pEvent) {
            promiseDict.reject({xhr: xhttp, error_code: "abort", error: "file connection has been aborted"});
        }
        xhttp.open("get", getUrl, true);
        xhttp.setRequestHeader("Content-Type", "text/plain; charset=UTF-8");
        xhttp.send();

        return this.loadingDef;
    },

    getData: function(){
        return this.content;
    },
    
    getDataObject: function() {
        if (Array.isArray(this.content) && this.content.length > 0 && this.content[0] && typeof this.content[0] === "object" && !Array.isArray(this.content[0])) {
            return structuredClone(this.content[0]);
        } else if (this.content && typeof this.content === "object" && !Array.isArray(this.content)) {
            return structuredClone(this.content);
        } else {
            return null;
        }
    },

    _guessIdentifierKey: function(pObject) {
        if (pObject["_id"] !== undefined) {
            return "_id";
        } else if (pObject["id"] !== undefined) {
            return "id";
        } else if (pObject["ID"] !== undefined) {
            return "ID";
        } else {
            return null;
        }
    },

    /**
     * @description Add a new object the the collection
     * @function
     * @name FileConnection#create
     * @param {Object} pObject The object to add to the collection
     * @param {Object} pOptions 
     * @param {Function} pGoodCB Function called when the object has been created correctly
     * @param {Function} pErrorCB Function called when an error occured
     * @returns Deferred
     */
    create: function(pObject, pOptions, pGoodCB, pErrorCB) {
        var that = this;
        // get options and apply defaults
        var options = Object.assign({"uniqKeyName": "_id", "addBirth": true}, pOptions);
        // deep copy of object to create
        var objectToCreate = Object.assign({}, pObject);
        this.loadingDef = this.load();
        return Promise.all([this.loadingDef]).then(function() {
            var indentifierKey = options.uniqKeyName;
            if (Array.isArray(that.content)) {
                // guess the id to be used
                if (that.content.length > 0) {
                    indentifierKey = that._guessIdentifierKey(that.content[that.content.length - 1]);
                    if (indentifierKey === null) {
                        indentifierKey = options.uniqKeyName;
                    }
                }
            } else {
                // make new content
                that.content = [];
            }
            // generate and add id
            objectToCreate[indentifierKey] = GUID.generate();
            // add birth key
            if (options.addBirth === true) {
                objectToCreate["birth"] = timeStamp();
            }
            // append to other rows
            that.content.push(objectToCreate);
            // save
            return that.update_all(that.content).then(function(){
                // good callback
                if (typeof pGoodCB === "function") {
                    pGoodCB(objectToCreate);
                }
                return objectToCreate;
            }).catch(function(pError){
                if (typeof pErrorCB === "function") {
                    pErrorCB(pError);
                }
                return Promise.reject(pError);
            });
        }, function(pError){
            if (typeof pErrorCB === "function") {
                pErrorCB(pError);
            }
            return Promise.reject(pError);
        });
    },

    /**
     * @description Get an filter certain objects from the collection. Same interface as the list_with_options api calls
     * @function
     * @name FileConnection#list_with_options
     * @param {Array.<String>} pQuery The query to filter. Same interface as portal api querys
     * @param {Array.<String>} pOrderby The order by. Same interface as portal api
     * @param {Array.<String>} pFields the fields to retrieve. Same interface as portal api
     * @param {Object} pOptions Same interface as portal api
     * @param {Function} pGoodCB Function called then we could retrieve the objects
     * @param {Fucntion} pErrorCB Function called when an error occured
     * @returns {Array.<Object>} The filtered object 
     */
    list_with_options: function(pQuery, pOrderby, pFields, pOptions, pGoodCB, pErrorCB) {
        var that = this;
        var skip = 0;
        var limit = undefined;
        var last = undefined;
        if (pOptions) {
            //  {first: pSkip, maximum: pLimit}
            if (pOptions.first !== undefined) {
                skip = parseInt(pOptions.first);
            }
            if (pOptions.maximum !== undefined) {
                limit = parseInt(pOptions.maximum);
            }
            if (pOptions.last !== undefined) {
                last = parseInt(pOptions.last);
            }
        }
        this.loadingDef = this.load();
        return Promise.all([this.loadingDef])
        .catch(function(pError){
            if (typeof pErrorCB === "function") {
                pErrorCB(pError);
            }
            return Promise.reject(pError);
        }).then(function() {
            var contentRows;
            if (Array.isArray(that.content)) {
                contentRows = that.content;
            } else if (that.content === undefined) {
                contentRows = [];
            } else {
                contentRows = [that.content];
            }
            var rows = [];
            var returnObject = {};
            if (Array.isArray(pQuery) && pQuery.length > 0) {
                var queryApplier;
                var filteredData;
                try {
                    queryApplier = new QueryApplier(pQuery);
                    filteredData = queryApplier.apply(contentRows);
                } catch(e) {
                    if (typeof pErrorCB === "function") {
                        pErrorCB({error_code: "invalid_query", error: e});
                    }
                    return Promise.reject(e);
                }
                rows = Query.apply(filteredData, [], pOrderby, skip, limit, last);
                returnObject = {results: rows};
                if (pOptions.count === true) {
                    returnObject.count = filteredData.length;
                }
            } else {
                rows = Query.apply(contentRows, [], pOrderby, skip, limit, last);
                returnObject = {results: rows};
                if (pOptions.count === true) {
                    returnObject.count = contentRows.length;
                }
            }
            if (typeof pGoodCB === "function") {
                pGoodCB(returnObject);
            }
            return returnObject;
        });
    },

    _update: function(pQuery, pUpdateObject, pMerge, pOneLevelMerge, pFirstOnly){
        var queryApplier = new QueryApplier(pQuery);
        var count_updated = 0;
        var error = undefined;
        for (var i=0; i<this.content.length; i++) {
            if (queryApplier.validate(this.content[i]) === true) {
                if (this.content[i] !== undefined && pMerge === false) { 
                    if (this.content[i].save_id !== undefined) {
                        if (this.content[i].save_id !== pUpdateObject.save_id) {
                            this._setError("save_id_not_equal", "the save_id is not equal");
                            error = this.getError();
                            if (pFirstOnly === true) {
                                return {success: false, count_updated: count_updated, error: error};
                            } else {
                                continue;
                            }
                        } else {
                            pUpdateObject.save_id = GUID.generate();
                        }
                    }
                    if (typeof this.content[i].modification === "string" && this.content[i].modification.length > 17 && isNaN(new Date(this.content[i].modification)) === false) {
                        // update modification key 
                        pUpdateObject.modification = timeStamp();
                    }
                }
                if (pMerge === true) {
                    if (this.content[i].save_id !== undefined && this.content[i].save_id !== pUpdateObject.save_id) {
                        this._setError("save_id_not_equal", "the save_id is not equal");
                        error = this.getError();
                        if (pFirstOnly === true) {
                            return {success: false, count_updated: count_updated, error: error};
                        } else {
                            continue;
                        }
                    }
                    // merge with existing 
                    if (pOneLevelMerge === false) {
                        this.content[i] = $.extend(true, {}, this.content[i], pUpdateObject);
                    } else {
                        // keys can contain dots notations
                        for (var key in pUpdateObject) {
                            if (pUpdateObject.hasOwnProperty(key)) {
                                this.content[i] = CloudflowObject.setParameter(this.content[i], key, pUpdateObject[key]);
                            }
                        }
                    }
                    if (this.content[i].save_id !== undefined) {
                        // no check for the moment
                        this.content[i].save_id = GUID.generate();
                    }
                    if (typeof this.content[i].modification === "string" && this.content[i].modification.length > 17 && isNaN(new Date(this.content[i].modification)) === false) {
                        // update modification key 
                        this.content[i].modification = timeStamp();
                    }
                } else {
                    // replace with existing
                    this.content[i] = pUpdateObject;
                }
                count_updated++;
                if (pFirstOnly === true) {
                    break;
                }
            }
        }
        return {success: count_updated > 0, count_updated: count_updated, error: error};
    },

    /**
     * @description Tries to update an object. It will retrieve the unic indentifier (_id, id or ID) retrieve the old object
     * and replace it with the new object. it will also adapt the save_id and the modifier if present in old object
     * @function
     * @name FileConnection#update
     * @param {Object} pUpdateObject the new date of the object
     * @param {Array.<String>} pFindQuery the query to retrieve the object   
     * @param {Function} pGoodCB Function called when the update is done and constains the updatd object
     * @param {Function} pErrorCB Function called when an error occured
     * @returns Deferred
     */
    update: function(pUpdateObject, pFindQuery, pGoodCB, pErrorCB) {
        // make object and a deep copy of it
        var updateObject = structuredClone(Object.assign({}, pUpdateObject));
        if (this.content === null) {
            this.content = [updateObject];
            if (typeof pGoodCB === "function") {
                pGoodCB(updateObject);
            }
            return Promise.resolve(updateObject);
        }
        var searchQuery;
        if (Array.isArray(pFindQuery) && pFindQuery.length > 2) {
            searchQuery = pFindQuery;
        } else {
            var key = this._guessIdentifierKey(updateObject);
            if (typeof key === "string" && key.length > 0) {
                searchQuery = [key, "equal to", updateObject[key]];
            } else {
                this._setError("identification_not_found", "no identification has not been found");
                if (typeof pErrorCB === "function") {
                    pErrorCB(this.getError());
                }
                return Promise.reject(this.getError());
            }
        }
        if (Array.isArray(searchQuery) && searchQuery.length > 2) {
            var result = this._update(searchQuery, updateObject, false, false, true);
            if (result.error !== undefined) {
                if (typeof pErrorCB === "function") {
                    pErrorCB(result.error);
                }
                return Promise.reject(result.error);
            }
            if (result.success === false) {
                this._setError("object_not_found", "the updated object has not been found");
                if (typeof pErrorCB === "function") {
                    pErrorCB(this.getError());
                }
                return Promise.reject(this.getError());
            } else {
                return this.update_all(this.content).then(function(){
                    if (typeof pGoodCB === "function") {
                        pGoodCB(updateObject);
                    }
                    return Promise.resolve(updateObject);
                }, function(pError){
                    if (typeof pErrorCB === "function") {
                        pErrorCB(pError);
                    }
                    return Promise.reject(pError);
                });
            }
        } else {
            this._setError("object_not_found", "the updated object has not been found");
            if (typeof pErrorCB === "function") {
                pErrorCB(this.getError());
            }
            return Promise.reject(this.getError());
        }
    },

    update_all: function(pRows, pGoodCB, pErrorCB) {
        if (Array.isArray(pRows)) {
            var that = this;
            var content = JSON.stringify(pRows, null, 3);
            return this._save(content).then(function(){
                if (typeof pGoodCB === "function") {
                    pGoodCB(content);
                }
                return content;
            }, function(pError){
                if (pError && pError.error_code !== undefined) {
                    that._setError(pError.error_code, pError.error);
                }
                if (typeof pErrorCB === "function") {
                    pErrorCB(pError);
                }
                return Promise.reject(that.getError());
            });
        } else {
            this._setError("wrong_parameter", "content must be an array");
            if (typeof pErrorCB === "function") {
                pErrorCB(this.getError());
            }
            return Promise.reject(this.getError());
        }
        
    },

    /**
     * @description Calculates the amount of objects matching a certain filter
     * @function
     * @name FileConnection#count
     * @param {Array} pQuery The filter query. Same interface as portal apis
     * @param {Function} pGoodCB Function called with parameter "count", the amount of matched objects 
     * @param {Function} pErrorCB Function called when an error occured
     * @returns Deferred
     */
    count: function(pQuery, pGoodCB, pErrorCB) {
        var that = this;
        this.loadingDef = this.load();
        return Promise.all([this.loadingDef]).then(function() {
            var contentRows;
            if (Array.isArray(that.content)) {
                contentRows = that.content;
            } else if (that.content === undefined) {
                contentRows = [];
            } else {
                contentRows = [that.content];
            }
            var count;
            if (Array.isArray(pQuery) && pQuery.length > 0) {
                var queryApplier = new QueryApplier(pQuery);
                count = queryApplier.apply(contentRows).length;
            } else {
                count = contentRows.length;
            }
            if (typeof pGoodCB === "function") {
                pGoodCB({count: count});
            }
            return {count: count};
        }, function(pError){
            if (typeof pErrorCB === "function") {
                pErrorCB(pErrorCB);
            }
            return Promise.reject(that.getError());
        });
    },
    
    /**
     * @description Update partially an object of the collection
     * @function
     * @name FileConnection#set_keys
     * @param {String} pID The id of the object
     * @param {Object} pKeyData the object containing the new key values to update. Same interface as portal api calls 
     * @param {Function} pGoodCB Function called when object has been updated 
     * @param {Function} pErrorCB Function called when an error occured
     * @returns Deferred
     */
    set_keys: function(pID, pKeyData, pGoodCB, pErrorCB){
        var that = this;
        this.loadingDef = this.load();
        return Promise.all([this.loadingDef]).then(function() {
            var contentRows;
            if (Array.isArray(that.content)) {
                contentRows = that.content;
            } else if (that.content === undefined) {
                contentRows = [];
            } else {
                contentRows = [that.content];
            }
            if (Array.isArray(contentRows) && contentRows.length > 0) {
                var key = that._guessIdentifierKey(contentRows[0]);
                if (key === null) {
                    that._setError("identification_not_found", "no identification has not been found");
                    if (typeof pErrorCB === "function") {
                        pErrorCB(that.getError());
                    }
                    return Promise.reject(that.getError());
                } else {
                    var result = that._update([key, "equal to", pID], pKeyData, true, true, true);
                    if (result.count_updated > 0) {
                        // only update if some data changed
                        return that.update_all(that.content).then(function(){
                            if (result.error !== undefined) {
                                if (typeof pErrorCB === "function") {
                                    pErrorCB(result.error);
                                }
                                return Promise.reject(result.error);
                            } else {
                                if (typeof pGoodCB === "function") {
                                    pGoodCB({});
                                }
                                return Promise.resolve({});
                            } 
                        }).catch(function(pError) {
                            if (typeof pErrorCB === "function") {
                                pErrorCB(pError);
                            }
                            return Promise.reject(pError);
                        });
                    } else if (result.error !== undefined) {
                        if (typeof pErrorCB === "function") {
                            pErrorCB(result.error);
                        }
                        return Promise.reject(result.error);
                    } else {
                        that._setError("object_not_found", "no object found with id " + pID);
                        if (typeof pErrorCB === "function") {
                            pErrorCB(that.getError());
                        }
                        return Promise.reject(that.getError());
                    }
                }
            } else {
                that._setError("object_not_found", "no object found with id " + pID);
                if (typeof pErrorCB === "function") {
                    pErrorCB(that.getError());
                }
                return Promise.reject(that.getError());
            } 
        }, function(pError){
            if (typeof pErrorCB === "function") {
                pErrorCB(pError);
            }
            return Promise.reject(that.getError());
        });
    },

    /**
     * @description Update all objects partial who match the filter query. Same interface as portal api calls
     * @function
     * @name FileConnection#set_keys_by_query
     * @param {Array} pQuery 
     * @param {Object} pKeyData 
     * @param {Object} pOptions 
     * @param {Function} pGoodCB 
     * @param {Function} pErrorCB 
     * @returns Deferred
     */
    set_keys_by_query: function(pQuery, pKeyData, pOptions, pGoodCB, pErrorCB) {
        var that = this;
        this.loadingDef = this.load();
        return Promise.all([this.loadingDef]).then(function(){
            if (that.content === null) {
                // success even if no items are found
                if (typeof pGoodCB === "function") {
                    pGoodCB({});
                }
                return Promise.resolve({});
            }
            var result = that._update(pQuery, pKeyData, true, true, false);
            if (result.count_updated > 0) {
                // only update if some data changed
                return that.update_all(that.content).then(function(){
                    if (result.error !== undefined) {
                        if (typeof pErrorCB === "function") {
                            pErrorCB(result.error);
                        }
                        return Promise.reject(result.error);
                    } else {
                        if (typeof pGoodCB === "function") {
                            pGoodCB({});
                        }
                        return Promise.resolve({});
                    } 
                }).catch(function(pError) {
                    if (typeof pErrorCB === "function") {
                        pErrorCB(pError);
                    }
                    return Promise.reject(pError);
                });
            } else if (result.error !== undefined) {
                if (typeof pErrorCB === "function") {
                    pErrorCB(result.error);
                }
                return Promise.reject(result.error);
            } else {
                // success even if no items are found
                if (typeof pGoodCB === "function") {
                    pGoodCB({});
                }
                return Promise.resolve({});
            }
        }, function(pError){
            if (typeof pErrorCB === "function") {
                pErrorCB(pError);
            }
            return Promise.reject(that.getError());
        });
    },

    /**
     * @description Delete an object from the collection. 
     * @function
     * @name FileConnection#delete
     * @param {String} pID The identifier of the object you want to delete out of the collection
     * @param {Function} pGoodCB function called when the object is deleted out of the collection, with a parameter array delete_ids
     * @param {Function} pErrorCB Function called when an error occured
     * @returns Deferred
     */
    delete: function(pID, pGoodCB, pErrorCB){
        var that = this;
        this.loadingDef = this.load();
        return Promise.all([this.loadingDef]).then(function() {
            var contentRows;
            if (Array.isArray(that.content)) {
                contentRows = that.content;
            } else if (that.content === undefined) {
                contentRows = [];
            } else {
                contentRows = [that.content];
            }
            if (Array.isArray(contentRows) && contentRows.length > 0) {
                var key = that._guessIdentifierKey(contentRows[0]);
                if (key === null) {
                    that._setError("identification_not_found", "no identification has not been found");
                    if (typeof pErrorCB === "function") {
                        pErrorCB(that.getError());
                    }
                    return Promise.reject(that.getError());
                } else {
                    return that._delete_by_query([key, "equal to", pID], pGoodCB, pErrorCB);
                }
            } 
        }, function(pError){
            if (typeof pErrorCB === "function") {
                pErrorCB(pError);
            }
            return Promise.reject(that.getError());
        });
    },

    /**
     * @description Delete all matching objects from the collection 
     * @function
     * @name FileConnection#delete_by_query
     * @param {Array.<String>} pQuery The query to match all objects you want to delete
     * @param {Function} pGoodCB function called when all objects are deleted out of the collection, with a parameter array delete_ids
     * @param {Function} pErrorCB Function called when an error occured
     * @returns Deferred
     */
    delete_by_query: function(pQuery, pGoodCB, pErrorCB){
        var that = this;
        this.loadingDef = this.load();
        return Promise.all([this.loadingDef]).then(function() {
            return that._delete_by_query(pQuery, pGoodCB, pErrorCB);
        }, function(pError){
            if (typeof pErrorCB === "function") {
                pErrorCB({error: pError.error_code, error_message: pError.error});
            }
            return Promise.reject(that.getError());
        });
    },

    _delete_by_query: function(pQuery, pGoodCB, pErrorCB){
        var contentRows;
        if (Array.isArray(this.content)) {
            contentRows = this.content;
        } else if (this.content === undefined) {
            contentRows = [];
        } else {
            contentRows = [this.content];
        }
        var deleted_ids = [];
        var removedItem, removedKey;
        if (Array.isArray(pQuery) && pQuery.length > 0) {
            var queryApplier = new QueryApplier(pQuery);
            for (var i=contentRows.length; i>=0; i--) {
                if (queryApplier.validate(contentRows[i])) {
                    // item to remove found
                    removedItem = contentRows.splice(i, 1);
                    removedKey = this._guessIdentifierKey(removedItem[0]);
                    if (typeof removedKey === "string" && removedKey.length > 0) {
                        deleted_ids.push(removedItem[0][removedKey]);
                    } else {
                        console.error("remove key path not found");
                    }
                }
            }
        } 
        return this.update_all(contentRows).then(function(){
            if (typeof pGoodCB === "function") {
                pGoodCB({deleted_ids: deleted_ids});
            }
            return {deleted_ids: deleted_ids};
        }, function(pError){
            if (typeof pErrorCB === "function") {
                pErrorCB(pError);
            }
            return Promise.reject(pError);
        });
    },

    touch: function(){
        var that = this;
        return new Promise(function(pResolve, pReject){
            api_async.file.does_exist(that.cloudflowURL.getCloudflowPath(), function(pResult) {
                /*
                    exists: false
                    is_folder: false
                    url: "cloudflow://PP_FILE_STORE/Menu/sitemap%20met%20%c3%a8.json"
                    valid: true
                */
                if (pResult !== undefined) {
                    if (pResult.valid === false) { // folders does not exists, so create them....
                        FileConnection.createParentFolders(pResult.url).then(function(){
                            that.update_all([], function(){
                                that.cloudflowURL = new CloudflowURL(pResult.url);
                                that.autoAdaptedURL = "after_touch";
                                pResolve({
                                    exists: false,
                                    url: pResult.url,
                                    valid: pResult.valid,
                                });
                            }, pReject);
                        }, pReject);
                    } else if (pResult.exists === false) {
                        that.update_all([], function(){
                            that.cloudflowURL = new CloudflowURL(pResult.url);
                            that.autoAdaptedURL = "after_touch";
                            pResolve({
                                exists: false,
                                url: pResult.url,
                                valid: pResult.valid,
                            });
                        }, pReject);
                    } else if (pResult.exists === true) {
                        pResolve(pResult);
                    } else {
                        pReject("wrong returning result");
                    }
                } else {
                    pReject("wrong returning result");
                }
            }, pReject);
        });
    },
    
    _save: function(pContent) {
        var that = this;
        var content = pContent;
        if  (that.rootParameter === "documents") {
            content = {
                documents: pContent
            }
        }
        var session = "";
        if (api_util.get_session() !== undefined) {
            session = "&session=" + api_util.get_session();
        }
        var checks = "";
        if (typeof that.fileEtag === "string" && that.fileEtag.length > 0) {
            if (that.fileEtag.indexOf("mod=") === 0) {
                checks = "&check_modification=" + that.fileEtag.slice(4);
            } else {
                checks = "&check_etag=" + that.fileEtag;
            }
        } else if (typeof that.fileModification === "number") {
            checks = "&check_modification=" + that.fileModification;
        }
        var boundary = "----cloudflowfileconnection" + Date.now();
        // attention keep this header clean,
        // header need to use \r\n for new lines
        // header may not have spaces before or after header keys
        var sendContent = "--" + boundary + '\r\nContent-Type: text/json\r\nContent-Disposition: form-data;filename="dumyblabla.json"\r\n\r\n' + content;
        sendContent = sendContent + "\r\n--" + boundary + "--\r\n";
        var upload_url = "/portal.cgi?asset=upload_file&url=" + encodeURIComponent(that.cloudflowURL.getCloudflowPath()) + "&overwrite=true" + session + checks;
        var promiseDict = Promise.withResolvers();
        var xhttp = new XMLHttpRequest();
        xhttp.onload = function(pEvent) {
            if (xhttp.status < 200 || (xhttp.status > 299)) {
                var errorMessage = {
                    "error": "Could not save",
                    "error_code": "faild_saving"
                };
                if (typeof xhttp.responseText === "string") {
                    try { // try to retrieve error message
                        errorMessage = JSON.parse(xhttp.responseText);
                    } catch(e) {}
                }
                promiseDict.reject(errorMessage);
            } else {
                let data = null;
                if (typeof xhttp.responseText === "string" && xhttp.responseText.length > 0) {
                    try {
                        data = JSON.parse(xhttp.responseText);
                    } catch(e) {
                        return promiseDict.reject({
                            "error_code": "return_interface_not_json",
                            "error": e.message
                        })
                    }
                } else {
                    return promiseDict.reject({
                        "error_code": "empty_response",
                        "error": "The returning response is empty"
                    })
                }
                if (Array.isArray(data.files) && data.files.length === 1) {
                    // etag has been changed, but what is the new value??
                    that.fileEtag = ""; 
                    if (Array.isArray(data.file_info) && data.file_info.length === 1) {
                        if (typeof data.file_info[0].etag === "string") {
                            that.fileEtag = data.file_info[0].etag;
                        }
                        if (typeof data.file_info[0].modification === "number") {
                            that.fileModification = data.file_info[0].modification;
                        }
                    }
                    promiseDict.resolve({
                        "url": data.files[0],
                        "content": pContent
                    });
                } else if (Array.isArray(data.files) && data.files.length === 0) {
                    // file has been ignored!!!
                    promiseDict.reject({
                        "error_code": "Document not saved",
                        "error": "saving conflict, the file has been modified by somebody else"
                    })
                } else {
                    // realy strange thing
                    promiseDict.reject({
                        "error_code": "unknown_error",
                        "error": "return data has no files parameter"
                    });
                }
            } 
        }
        xhttp.onerror = function(pEvent) {
            var errorMessage = {
                "error": "Could not save",
                "error_code": "faild_saving"
            };
            if (typeof xhttp.responseText === "string") {
                try { // try to retrieve error message
                    errorMessage = JSON.parse(xhttp.responseText);
                } catch(e) {}
            }
            promiseDict.reject(errorMessage);
        }
        xhttp.onabort = function(pEvent) {
            promiseDict.reject({xhr: xhttp, error_code: "abort", error: "file connection has been aborted"});
        }
        xhttp.open("POST", upload_url);
        xhttp.setRequestHeader("Content-Type", "multipart/form-data; boundary=" + boundary);
        xhttp.send(sendContent);
        return promiseDict.promise;
    },

    
    stop: function(pReason){
        if (this.loadingDef !== undefined && this.loadingDef.readyState > 0 && this.loadingDef.readyState < 4) {
            this.loadingDef.abort("deprecated_results");
        }
        if (typeof pReason === "string") {
            this.reasonToStop = pReason;
        } else {
            this.reasonToStop = "???";
        }
    },

    clone: function(){
        return FileConnection.fromJSON(this.toJSON());
    },

    toJSON: function(){
        return {
            url: this.url,
            relativeBasePath: this.relativeBasePath,
            contentType: this.contentType
        };
    }
};

FileConnection.createParentFolders = function(pURL) {
    if (pURL.indexOf("cloudflow://") === 0) {
        pURL = pURL.slice(12);
    }
    if (pURL.endsWith(".json")){
        // make folder
        pURL = pURL.slice(0, pURL.lastIndexOf("/") + 1);
    }
    var firstSlashIndex = pURL.indexOf('/') + 1;
    var rootFolder = "cloudflow://" + pURL.substring(0, firstSlashIndex); 
    return api_defer.file.create_folder_with_options(rootFolder, pURL.slice(firstSlashIndex), {unique_name_mode: "None", create_folders: true})
    .then(function(result) {
        if (result && typeof result.created_folder === "string" && result.created_folder.length > 0) {
            return {"url": result.created_folder};
        } else {
            return Promise.reject({"error_code": "wrong_return_interface", "error": "wrong return value api.file.create_folder"});
        }
    }, function(pError) {
        console.error(pError);
        return Promise.reject(pError);
    }); 
}


module.exports = FileConnection;